import React from "react";
import {
  SimpleShowLayout,
  TextField,
  NumberInput,
  TextInput
} from "react-admin";
import { perGameCalc, getPerGameStatValue } from "util/stats";
import _ from "lodash";
import { useFormState, useForm } from "react-final-form";

const FormTab = (props) => {
  const { values } = useFormState();
  const form = useForm();

  const updateStat = (event, updateField) => {
    const gameCount = _.get(values, "soccer.teamGameCount");
    const perGameStat = getPerGameStatValue(event, gameCount);
    form.change(`soccer.${updateField}`, perGameStat);
  };

  const updateAllRelatedStats = (event) => {
    if (!event || !event.target) return;
    const { value } = event.target;
    const stats = _.get(values, "soccer");
    const { totalGoals, goalsAgainst } = stats;
    const goalsPerGame = perGameCalc(totalGoals, value);
    const goalsAgainstPerGame = perGameCalc(goalsAgainst, value);

    form.change("soccer.goalsPerGame", goalsPerGame);
    form.change("soccer.goalsAgainstPerGame", goalsAgainstPerGame);
  };
  return (
    <SimpleShowLayout {...props}>
      <TextField source="soccer.id" />
      <NumberInput source="soccer.seasonWins" />
      <NumberInput source="soccer.seasonLosses" />
      <NumberInput source="soccer.seasonTies" />
      <NumberInput source="soccer.seasonPercentWins" />
      <NumberInput source="soccer.districtWins" />
      <NumberInput source="soccer.districtLosses" />
      <NumberInput source="soccer.districtTies" />
      <NumberInput source="soccer.districtPercentWins" />
      <NumberInput source="soccer.homeWins" />
      <NumberInput source="soccer.homeLosses" />
      <NumberInput source="soccer.homeTies" />
      <NumberInput source="soccer.roadWins" />
      <NumberInput source="soccer.roadLosses" />
      <NumberInput source="soccer.roadTies" />
      <TextInput source="soccer.streak" />
      <NumberInput source="soccer.differential" />

      <NumberInput
        source="soccer.teamGameCount"
        onChange={updateAllRelatedStats}
      />
      <NumberInput
        source="soccer.totalGoals"
        onChange={(e) => updateStat(e, "goalsPerGame")}
      />
      <NumberInput
        source="soccer.goalsAgainst"
        onChange={(e) => updateStat(e, "goalsAgainstPerGame")}
      />
      <NumberInput source="soccer.goalsPerGame" />
      <NumberInput source="soccer.goalsAgainstPerGame" />
    </SimpleShowLayout>
  );
};

export default FormTab;
